import { cva } from 'class-variance-authority'

export const insightsVariants = cva('w-full rounded bg-main-background-subtle-semantic-ai p-4', {
  variants: {
    variant: {
      default: '',
      inactive: 'bg-main-background-muted',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
})
